import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const BlogPostCard = ({
  title,
  previewImage,
  previewText,
  blogCategory,
  url,
}) => (
  <Card className="border-0 h-100 overflow-hidden bg-transparent">
    <a href={url} className="d-block image-hover stretched-link">
      <Card.Img
        variant="top"
        src={previewImage.url}
        width={previewImage.width}
        height={previewImage.height}
        alt={previewImage.alt}
      />
    </a>

    <Card.Body className="px-0 pb-0 space-y-2">
      <h3 className="d-block text-reset text-decoration-none">{title}</h3>

      {blogCategory && (
        <div className="text-tertiary">{blogCategory.title}</div>
      )}
      <div>{parse(previewText)}</div>
    </Card.Body>
  </Card>
);

export default BlogPostCard;

BlogPostCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  previewText: PropTypes.string.isRequired,
  blogCategory: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  url: PropTypes.string.isRequired,
};
